/**
 * Third-Party Integrations Configuration
 *
 * Centralized config for Cloudflare Turnstile, Pardot, and other external services.
 * Keys and URLs are loaded from environment variables where possible.
 */

// ============================================================================
// CLOUDFLARE TURNSTILE
// ============================================================================

export const TURNSTILE_CONFIG = {
  /** Turnstile site key (public — used in frontend widget) */
  siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',

  /** Whether Turnstile verification is enabled */
  enabled: Boolean(process.env.REACT_APP_TURNSTILE_SITE_KEY),
};

// ============================================================================
// PARDOT FORM HANDLER
// ============================================================================

export const PARDOT_CONFIG = {
  /** Pardot form handler URL — set this to your Pardot endpoint */
  formHandlerUrl: process.env.REACT_APP_PARDOT_FORM_HANDLER_URL || '',

  /**
   * Master toggle for Pardot submissions.
   * Set REACT_APP_PARDOT_ENABLED=true in .env to enable.
   * Submissions will only fire when BOTH this is true AND formHandlerUrl is set.
   */
  enabled:
    process.env.REACT_APP_PARDOT_ENABLED === 'true' &&
    Boolean(process.env.REACT_APP_PARDOT_FORM_HANDLER_URL),
};
